import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRInput } from 'src/app/models/qr-input.model';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserPasswordService } from 'src/app/services/user-password.service';
import { FormGroup } from '@angular/forms';

type InputTypes = string | number | undefined;

@Component({
  selector: 'app-update-first-password',
  templateUrl: './update-first-password.component.html',
  styleUrls: ['./update-first-password.component.scss'],
})
export class UpdateFirstPasswordComponent {
  //--------------------Inputs & Outputs--------------------
  @Input() loggedUser: any;
  @Output() updateFinished: EventEmitter<boolean> = new EventEmitter<boolean>();

  //--------------------Variables--------------------

  visible: boolean = true;
  newPassword: string = '';
  oldPassword: string = '';
  repeatOldPassword: string = '';
  formData: any = new FormData();

  errors: {
    [key: string]: { error: boolean; message: string[] };
  } = {
    length: { error: true, message: ['Debe tener entre 8 y 12 caracteres.'] },
    caps: { error: false, message: ['Hace falta minimo 1 letra mayúscula.'] },
    number: { error: false, message: ['Hace falta minimo 1 número.'] },
    specChar: {
      error: false,
      message: ['No debe contener caracteres especiales.'],
    },
    userSimilar: { error: false, message: ['No debe ser igual al usuario.'] },
    notSimilar: { error: false, message: ['Las contraseñas no coinciden.'] },
  };

  //--------------------Inputs--------------------
  currentPasswordConfig: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    type: 'password',
  };
  newPasswordConfig: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    type: 'password',
  };
  repeatPasswordConfig: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    type: 'password',
  };

  //--------------------Buttons--------------------
  buttonSubmitConfig: QRButton = {
    viewValue: 'Guardar',
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
  };
  buttonCancelConfig: QRButton = {
    viewValue: 'Cancelar',
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
  };

  constructor(
    private readonly userPasswordService: UserPasswordService,
    private readonly snackbarService: SnackbarService
  ) {}

  registerForm: any = FormGroup;

  currentPasswordChange(value: InputTypes): void {
    if (value) {
      this.oldPassword = value.toString();
    }
  }

  newPasswordChange(value: InputTypes): void {
    if (value) {
      this.newPassword = value.toString();

      this.errors['length'].error = false;
      this.errors['caps'].error = false;
      this.errors['number'].error = false;
      this.errors['specChar'].error = false;
      this.errors['userSimilar'].error = false;

      if (!this.newPassword) {
        return;
      }
      // Length
      if (this.newPassword.length < 8 || this.newPassword.length > 12) {
        this.errors['length'].error = true;
      }

      // Caps
      if (!/[A-Z]/.test(this.newPassword)) {
        this.errors['caps'].error = true;
      }

      // Number
      if (!/\d/.test(this.newPassword)) {
        this.errors['number'].error = true;
      }

      // Special Char
      if (/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.newPassword)) {
        this.errors['specChar'].error = true;
      }

      // User
      if (this.newPassword == this.loggedUser.username) {
        this.errors['userSimilar'].error = true;
      }
    }
  }

  repeatPasswordChange(value: InputTypes): void {
    if (value) {
      this.errors['notSimilar'].error = false;
      if (value != this.newPassword) {
        this.errors['notSimilar'].error = true;
      } else {
        this.repeatOldPassword = value.toString();
      }
    }
  }
  //--------------------Buttons functions--------------------
  async save() {
    if (
      !this.errors['length'].error &&
      !this.errors['caps'].error &&
      !this.errors['number'].error &&
      !this.errors['specChar'].error &&
      !this.errors['userSimilar'].error
    ) {
      const dto = {
        user: this.loggedUser.username,
        userId: this.loggedUser.id,
        newPassword: this.newPassword,
      };
      this.userPasswordService.post(dto, '').then((res: any) => {
        if (res?.success) {
          this.snackbarService.openSnackBar(res.responseMsg, '');
          this.visible = false;
          this.updateFinished.emit(true);
        } else {
          this.snackbarService.openSnackBar(res.responseMsg, '');
        }
      });
    }
  }
  close() {
    this.visible = false;
  }
}
